<div class="word-count-container">
	<div class="titleContainer" *ngIf="titleShow">
		<h2>Word Cloud</h2>
	</div>
	<div style="width: 100%">
		<div id="wordCloudContainer"></div>
	</div>
	<!--<div class="flex justify-center items-center">
		<button (click)="refreshData()" class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded inline-flex items-center">
			<span class="material-icons">autorenew</span>
			<span>Reload Word Cloud</span>
		</button>
	</div>-->
</div>
